// frontend/src/components/common/ContractBadge.js
import React from "react";

const ContractBadge = ({ contract }) => {
  const colors = {
    Free: "bg-[#84BD00] text-white", // burnair Green
    Registered: "bg-gray-100 text-[#002855]", // Light grey with burnair Blue text
    Basic: "bg-[#23CEE7] text-white", // Basic contract color
    Premium: "bg-[#FC0058] text-white", // Premium contract color (burnair red variant)
    Pro: "bg-black text-white", // Pro contract color
  };

  return (
    <span
      className={`inline-flex items-center px-2 py-1 text-xs font-medium rounded-full ${
        colors[contract] || colors.Free
      }`}
    >
      {contract}
    </span>
  );
};

export default ContractBadge;
